import HyperLink from '@acorn-portal/shared/src/components/hyperlink';
import { Typography } from '@mui/material';
import { IFooterDetail } from '@acorn-portal/shared/src/components/footer';

export const FooterDetails: IFooterDetail[] = [
	{
		title: 'Terms of Business',
		content: (
			<Typography
				component='a'
				href='https://www.streetcover.co.uk/toba'
				target='_blank'
				rel='noreferrer'
				sx={{ color: 'white' }}
			>
				Our Terms of Business
			</Typography>
		),
	},
	{
		title: 'Registered Office Details',
		content: (
			<Typography>
				Street Cover is a trading name of Acorn Insurance and Financial Services Ltd which is authorised and regulated
				by the Financial Conduct Authority (FCA)
				<br />
				registration number 311873. Registered address: 98 Liverpool Road, Formby, Liverpool, Merseyside, L37 6BS, No.
				01636368.
			</Typography>
		),
	},
	{
		title: 'Contact Us',
		content: (
			<Typography>
				To get in touch, please{' '}
				<Typography component='a' href='https://streetcover.co.uk/contact-us/' target='_blank' sx={{ color: 'white' }}>
					click here
				</Typography>
			</Typography>
		),
	},
	{
		title: 'Privacy Notice',
		content: (
			<Typography
				component='a'
				href='https://www.streetcover.co.uk/docs/Terms/Privacy-Policy.pdf'
				target='_blank'
				sx={{ color: 'white' }}
			>
				Our Privacy Notice.
			</Typography>
		),
	},
];

const Copy = {
	keepingInformed: (
		<>
			Acorn Insurance and affiliated companies in our Group would like to occasionally contact you to tell you about new
			products, special offers and promotions, so you don&apos;t miss out. Further information can be found in our{' '}
			<HyperLink
				href='https://motorcade.co.uk/wp-content/uploads/2021/02/Privacy-Notice-Acorn-Insurance-and-Financial-Services-Limited-February-2021.pdf'
				target='_blank'
				rel='noreferrer'
			>
				Privacy Notice
			</HyperLink>
			. If you&apos;d prefer not to hear from us, please tick the relevant boxes below.
		</>
	),
};

export default Copy;
